import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { Fragment, memo, useCallback, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { StepperForm } from 'shell/view-models/stepper-form';
import { FamilyVM } from 'shell/view-models/family-member';
import AccordionPersonForm from './form';
// import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import { AnprVM } from 'shell/view-models/search-anpr';
// import { useUserProfile } from 'shell/hooks/use-user-profile';

interface AccordionPersonProps {
  disabled?: boolean;
  familyMembers?: AnprVM<FamilyVM>;
}

const AccordionPersonComponent = ({ disabled }: AccordionPersonProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<StepperForm>();

  const onFieldPersonChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('person', {
        ...formContext.values.person,
        [key]: value,
      });
    },
    [formContext.values.person, formContext.setFieldValue]
  );

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-person-content"
          id="panel-person-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Persona</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AccordionPersonForm
            disabled={disabled}
            values={formContext.values.person || null}
            // generality={formContext.values.generality}
            citizenship={formContext.values.citizenship}
            family={formContext.values.familyCoexistence}
            isForPersonDetailPage
            onChange={onFieldPersonChange}
            statoCFGeneralita={formContext.values.statoCFGeneralita}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionPersonComponent.displayName = 'Accordion person component';

const AccordionPerson = memo(AccordionPersonComponent);

export default AccordionPerson;
